/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function (
  themeCurrency
) {

  window.cartTotal = 0.0;
  if (typeof window.cartTotal === 'undefined') {
    window.cartTotal = 0.0;
  }

  window.isCartLoading = false;
  if (typeof window.isCartLoading === 'undefined') {
   window.isCartLoading = false;
  }

  const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
  const checkoutButtons = document.querySelectorAll('[name="checkout"]');
  const cartSubtotals = document.querySelectorAll('[data-cart-final]');

  const syncCartFinalTotals = (cart) => {
    if (!cart || !cartSubtotals.length) return;

    const subtotalCents = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
    const formattedSubtotal = themeCurrency.formatMoney(subtotalCents, theme.moneyFormat);

    cartSubtotals.forEach((subtotalNode) => {
      subtotalNode.textContent = formattedSubtotal;
    });
  };

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      //console.log("Container ———————— ↓");
      //console.log(container);
      //console.log("Variant —————————— ↓");
      //console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", async function (event) {
    var cart = event.detail.cart;
    if (cart) {
      //console.log("Cart ———————————— ↓");
      //console.log(cart);
      // ... update an app or a custom shipping caluclator
      await transformCartItems(cart);
      syncCartFinalTotals(cart);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    //console.log("theme:cart:init");
    //console.log(e);
  });

  document.addEventListener("theme:cart:reload", async () => {
    const latestCart = await fetch("/cart.js").then((response) => response.json()).catch(() => null);
    syncCartFinalTotals(latestCart);
  });


  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    //console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // A cart change was rejected (e.g. cart validation 422): no cart:change will fire,
  // so unlock the cart UI here.
  document.addEventListener("theme:cart:error", () => {
    sessionStorage.removeItem("TRANSFORMING_CART");
    configureButtons();
  });

  document.addEventListener("theme:add:inProgress", (e) => {
    sessionStorage.setItem("TRANSFORMING_CART", "true");
    configureButtons();
    addToCartButtons.forEach((button) => {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    });
  });

  /*-----------------------------------------------------------------------------*/

  const configureButtons = () => {
    const transforming = sessionStorage.getItem("TRANSFORMING_CART") === "true";
    const lineItemsWrappers = document.querySelector("[data-line-items]");
    if (!transforming) {
      addToCartButtons.forEach((button) => {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
      });
      checkoutButtons.forEach((button) => {
        button.disabled = false;
        // Conditioned products without the minimum keep the checkout locked.
        if (window.__conditionedBlocked) {
          button.disabled = true;
          button.classList.add("disabled");
        }
      });
      lineItemsWrappers.style.pointerEvents = "auto";
      lineItemsWrappers.style.opacity = "1";
      return;
    }
    addToCartButtons.forEach((button) => {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    });
    checkoutButtons.forEach((button) => {
      button.disabled = true;
    });
    lineItemsWrappers.style.pointerEvents = "none";
    lineItemsWrappers.style.opacity = "0.5";
  };

  // password visibility toggle
  const passwordVisibilityToggles = document.querySelectorAll("[data-password-visibility-toggle]");

  passwordVisibilityToggles.forEach((toggle) => {
    const parent = toggle.closest("[data-password-visibility-wrap]");
    const passwordInput = parent.querySelector("input");

    toggle.addEventListener("click", () => {
      toggle.classList.toggle("is-visible");
      if (passwordInput.type == "password") {
        passwordInput.type = "text";
      } else passwordInput.type = "password";
    });
  });

  // Line keys of cart items whose product has the "conditioned" tag. Cart JSON has no
  // product tags, so they come from the alternate cart view templates/cart.conditioned.liquid.
  // This covers every add-to-cart path (quick-order, quick-add, ...), not only the
  // forms that send the _conditioned line item property.
  const getConditionedLineKeys = async () => {
    try {
      // No Accept: application/json header: with it Shopify answers with the plain cart JSON
      // and ignores the alternate view, so the tagged lines would never be found.
      const response = await fetch(`${window.theme.routes.cart}?view=conditioned`);
      const data = JSON.parse(await response.text());
      if (!Array.isArray(data.keys)) console.error("cart?view=conditioned did not return the conditioned keys");
      return new Set(Array.isArray(data.keys) ? data.keys : []);
    } catch (error) {
      console.error("Error reading conditioned cart lines:", error);
      return new Set();
    }
  };

  // The minimum always comes from the backend service (shop metafield custom.conditioned_amount),
  // never from a theme fallback. null = the service has not answered yet or failed.
  let conditionedServiceAmount = null;

  const loadConditionedAmount = async () => {
    if (conditionedServiceAmount !== null) return conditionedServiceAmount;
    try {
      const response = await window.backend.getConditionedAmount();
      const amount = Number(response?.amount);
      if (amount > 0) conditionedServiceAmount = amount;
    } catch (error) {
      console.error("Error reading the conditioned minimum from the service:", error);
    }
    return conditionedServiceAmount;
  };

  const CONDITIONED_UNKNOWN_MESSAGE =
    "No se pudo consultar el monto mínimo de compra para productos condicionados. Intenta de nuevo en unos segundos.";

  // Same text the checkout Function, quick order and order edit use.
  const conditionedMessage = (amount) =>
    amount === null
      ? CONDITIONED_UNKNOWN_MESSAGE
      : `Tienes productos en tu carrito que requieren una compra mínima de $${Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} en productos regulares. Agrega más productos o quita esos productos para continuar.`;

  // Checkout lock for conditioned products. It only touches buttons it locked itself (marked with
  // data-conditioned-locked) and gives back only what it took, so the checkout handling of
  // Ganar Más, Regalón and kits (configureButtons, theme.dev.js) is not changed.
  let conditionedBlockAmount = null;

  const applyConditionedLock = () => {
    const blocked = window.__conditionedBlocked === true;
    const transforming = sessionStorage.getItem("TRANSFORMING_CART") === "true";
    // Fresh query: the cart drawer can be re-rendered, which leaves checkoutButtons stale.
    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      const parent = button.parentElement;
      let note = parent.querySelector(":scope > [data-conditioned-message]");

      if (blocked) {
        button.dataset.conditionedLocked = "true";
        button.disabled = true;
        button.classList.add("disabled");
        if (!note) {
          note = document.createElement("div");
          note.className = "errors";
          note.setAttribute("data-conditioned-message", "");
          note.setAttribute("role", "alert");
          parent.insertBefore(note, button);
        }
        note.textContent = conditionedMessage(conditionedBlockAmount);
        return;
      }

      if (note) note.remove();
      // Give the button back, unless a cart transform is still running: configureButtons or the
      // next pass (cart transform completed / re-render) will finish it.
      if (button.dataset.conditionedLocked === "true" && !transforming) {
        delete button.dataset.conditionedLocked;
        button.disabled = false;
        button.classList.remove("disabled");
      }
    });
  };

  const setConditionedBlock = (blocked, amount) => {
    window.__conditionedBlocked = blocked;
    conditionedBlockAmount = amount;
    applyConditionedLock();
  };

  // configureButtons runs at the end of a cart transform and enables the checkout: apply the lock
  // again right after it (the event is dispatched after configureButtons).
  document.addEventListener("cartTransformCompleted:lock", () => {
    setTimeout(applyConditionedLock, 0);
  });

  // The drawer re-renders its HTML after a cart change: the new checkout buttons need the lock too.
  if (document.body) {
    let lockScheduled = false;
    new MutationObserver((mutations) => {
      const addedButton = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) => node.nodeType === 1 && (node.matches?.('[name="checkout"]') || node.querySelector?.('[name="checkout"]'))
        )
      );
      if (!addedButton || lockScheduled) return;
      lockScheduled = true;
      requestAnimationFrame(() => {
        lockScheduled = false;
        applyConditionedLock();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Locks the checkout and shows / hides the add buttons of conditioned products according to
  // the cart and the minimum from the service. Conditioned add buttons are rendered hidden and
  // only shown here, so a failing service leaves them hidden.
  const syncConditionedState = async (_cart) => {
    const conditionedAmount = await loadConditionedAmount();
    const taggedKeys = await getConditionedLineKeys();
    const conditionedProducts = _cart.items.filter(
      item => taggedKeys.has(item.key) || item?.properties?._conditioned == "true"
    );
    const cart_total = _cart.items_subtotal_price / 100;
    const conditionedTotal = conditionedProducts.reduce((sum, item) => sum + item.line_price, 0);
    const conditionedTotalDecimal = conditionedTotal / 100;
    const final_cart_total = cart_total - conditionedTotalDecimal;
    const thresholdMet = conditionedAmount !== null && final_cart_total >= conditionedAmount;

    // Conditioned products without the minimum are not removed: the checkout stays locked
    // and the buyer sees why. The conditioned-validation Function is the enforcement at checkout.
    setConditionedBlock(conditionedProducts.length > 0 && !thresholdMet, conditionedAmount);

    const products = document.querySelectorAll(`[data-is-conditioned-product]`);
    products.forEach((product) => {
      if (!thresholdMet) {
        product.style.display = 'none';
      } else if (product.style.display === 'none') {
        product.style.display = '';
      }
    });

    return thresholdMet;
  };

  const processingConditionedProducts = async (_cart) => {
    await syncConditionedState(_cart);
    return _cart;
  };

  // Product and collection pages load without a cart change: sync once on load.
  const initConditionedProducts = async () => {
    if (window.isQuickOrder || !(TYPE_USER == "Associate" || TYPE_USER == "Distributor")) return;
    const cart = await fetch(`${window.theme.routes.cart}.js`).then((response) => response.json()).catch(() => null);
    if (cart) await syncConditionedState(cart);
  };
  document.addEventListener("DOMContentLoaded", initConditionedProducts);

  const transformCartItems = async (cart) => {
    // A cart change went through: drop any stale error (e.g. a cart validation message
    // from a previously rejected change). Errors raised after this point re-show it.
    document.querySelectorAll("[data-form-errors]").forEach((errorElement) => {
      errorElement.style.display = "none";
      errorElement.innerHTML = "";
    });

    // Group items by id and variant_id
    const groupedItems = cart.items.reduce((acc, item) => {
      const key = `${item.id}:${item.variant_id}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    const hasDuplicates = Object.values(groupedItems).some((group) => group.length > 1);
    const limitedProducts = [];
    Object.values(groupedItems).forEach((group) => {
      group.forEach((item) => {
        document.querySelectorAll('.cart__items__row').forEach(row => {
          let limit= 0;
          if(row.dataset.itemLimit && row.dataset.cartItem === `${item.id}`)
            limit = row.dataset.itemLimit;
           if (limit === 0){
          const limitInput = document.getElementById(`weekly-limit-${item.product_id}`);
          if(limitInput?.value) {
            limit = parseInt(limitInput.value);
          }
          }
          const current = limitedProducts.find(p => p.id === item.product_id);
          if(!current && (limit > 0 || (item.properties && item.properties._weekly_limit))) {
            limitedProducts.push({
              key: item.key,
              id: item.product_id,
              quantity: item.quantity,
              limit: limit || parseInt(item.properties._weekly_limit) || 0,
            })
          }
        });

      });
    });

    let _cart = cart;

    if (hasDuplicates) {
      const updates = {};
      Object.values(groupedItems).forEach((group) => {
        const sortedGroup = group.sort((a, b) => parseInt(b.properties._t) - parseInt(a.properties._t));
        const mostRecentItem = sortedGroup[0];
        const totalQuantity = group.reduce((sum, item) => sum + item.quantity, 0);

        // Set quantity to 0 for all items except the most recent one
        group.forEach((item) => {
          updates[item.key] = 0;
        });

        // Set the total quantity for the most recent item
        updates[mostRecentItem.key] = totalQuantity;
      });

      _cart = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: updates }),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error("Error updating cart:", error);
        });
    }

   const drawerWrapper = document.querySelector(".upsell__sidebar__items");
    if(drawerWrapper) {
      const buttons = drawerWrapper.querySelectorAll("button");
      buttons.forEach((ele)=>{
        ele.style.display = "none"
      })
    }
    if (TYPE_USER == "Associate" || TYPE_USER == "Distributor") {
      _cart = await processingConditionedProducts(_cart);
    }

    if(limitedProducts.length > 0) {
      document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
        checkoutButtons.forEach((button) => {
        button.disabled = true;
      });
      sessionStorage.setItem("TRANSFORMING_CART", "true");
      configureButtons();
      await Promise.all(limitedProducts.map(async(item) => {
      const cart = await window.fetch(`${window.theme.routes.cart}.js`);
      const cartData = await cart.json();
      const existingItem = cartData.items.find(cartItem => cartItem.product_id === item.id);
       try{
        const checkLimitResponse = await fetch(`${AWS_API_URL}/Prod/products/${item.id}/check-limit?quantity=${existingItem.quantity}&customerId=${theme.customer_id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const checkLimitData = await checkLimitResponse.json();

        if(!checkLimitResponse.ok || (checkLimitData && checkLimitData.result)) {
          const updates = {};
          const excedent = checkLimitData.currentQuantity - item.limit;

          if(excedent > 0) {
            updates[item.key] = existingItem.quantity - excedent;
          } else {
            updates[item.key] = existingItem.quantity;
          }

          _cart = await fetch(`${window.theme.routes.cart}/update.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: updates}),
          })

          const errorElement = document.querySelector("[data-form-errors]");
          if (errorElement) {
            document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
            errorElement.innerHTML = LIMITED_PRODUCTS_CONFIGURATION_MESSAGE;
            errorElement.style.display = "";
            setTimeout(() => {
              errorElement.style.display = "none";
            }, 2500);
          }
        }
       }catch(e) {
        console.error("Error checking product limit:", e);
       } finally{
          sessionStorage.removeItem("TRANSFORMING_CART");
          configureButtons();
       }
      }));

    }

    document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
    sessionStorage.removeItem("TRANSFORMING_CART");
    configureButtons();

    window.isCartLoading = false;
    document.dispatchEvent(new CustomEvent('cartTransformCompleted:lock', { detail: { completed: true }}));

  };

  document.addEventListener("DOMContentLoaded", function () {
    if (!theme.storefront_partner) {
      let js = document.createElement("script");
      js.type = "text/javascript";
      js.async = 1;
      js.src = "https://go.botmaker.com/rest/webchat/p/M3ZOHJBAP1/init.js";
      document.body.appendChild(js);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})(
  themeVendor.themeCurrency
);
